import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./menu_item_category.js";
//#region src/menu_item_category_helper.ts
var menu_item_category_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(category) {
	switch (category) {
		case 0: return "Food";
		case 1: return "Alcoholic Beverage";
		case 2: return "Nonalcoholic Beverage";
		case 3: return "Other";
		case 4: return "Special Offer";
	}
}
//#endregion
export { menu_item_category_helper_exports, name };

//# sourceMappingURL=menu_item_category_helper.js.map